import React from 'react'
import './ContactProfile.scoped.sass'
import CreateContactModal from '@/components/SideMenu/components/ContactMenu/components/CreateContactModal/CreateContactModal'
import AddInfoModal from '@/components/SideMenu/components/ContactMenu/components/AddInfoModal/AddInfoModal'

import writeMessageService from '@/app-domains/messages/writing/WritingModal.service'
import WritingService from '@/app-domains/messages/draft/writing.service'

import modalService from '@/services/modal.service'
import contactsService from '@/app-domains/contacts/contacts.service'
import store from '@/core/store'

import { ReactComponent as ImageAvatar } from '@/assets/icons/avatar-image.svg'
import { ReactComponent as PhoneIcon } from '@/assets/icons/phone-icon.svg'
import { ReactComponent as LetterIcon } from '@/assets/icons/letter-icon.svg'
import { ReactComponent as WhiteLetterIcon } from '@/assets/icons/white-letter-icon.svg'
import { ReactComponent as WebsiteIcon } from '@/assets/icons/website-icon.svg'
import { ReactComponent as AddressIcon } from '@/assets/icons/address-icon.svg'
import { ReactComponent as NotesIcon } from '@/assets/icons/notes-icon.svg'
import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon.svg'
import { ReactComponent as DeleteIcon } from '@/assets/icons/red-delete-icon.svg'
// eslint-disable-next-line
import { ReactComponent as ExportIcon } from '@/assets/icons/export-icon.svg'
import { ReactComponent as LabelsIcon } from '@/assets/icons/labels-icon.svg'
import { AddLabelToContactModalContainer } from '@/components/SideMenu/components/ContactMenu/components/AddLabelToContactModalContainer/AddLabelToContactModalContainer'

const ContactProfile = (props) => {
  const { contact } = props

  function editProfile () {
    modalService.open(<CreateContactModal contact={contact} type='edit'/>, true)
  }

  async function sendEmail () {
    await WritingService.addToAddress(contact.emails && contact.emails[0])
    writeMessageService.open({ type: 'standalone-draft' })
  }

  async function deleteContact (contact) {
    await contactsService.removeContact(contact)
    store.commit('CONTACT_VIEW:UPDATED')
    store.commit('CONTACT_LIST:UPDATED', Object.values(contactsService.getAllStoredContacts()))
  }

  function openAddLabelToContactModal () {
    modalService.open(<AddLabelToContactModalContainer contact={contact}/>)
  }

  return (
    <div className='main-container'>
      <div className='contact-profile-container'>
        <div className='header-content'>
          <div className='header-left'>
            <div className='contact-image-div'>
              <span className='contact-image'>
                { contact.contactimageuri ? <img className='contact-image-img' src={contact.contactimageuri}/> : <ImageAvatar/> }
              </span>
            </div>
            <div className='contact-header-info'>
              <div className='contact-name'>
                {(contact.firstname || '') + ' ' + (contact.lastname || '')}
              </div>
              {contact.emails?.length > 0 && <>
                <div className='contact-email-address'>
                  {contact.emails[0]}
                </div>
                <div className='send-email-button' onClick={sendEmail}>
                  <><WhiteLetterIcon /> Send email</>
                </div></>}
            </div>
          </div>
          <div className='header-right'>
            <div className='edit-profile' onClick={editProfile}>
              <PencilIcon />
            </div>
          </div>
        </div>
        <div className='contact-container'>
          <div className='contact-info'>
            <div className='info-div'>
              <div className='part-left'>
                <div className='icon-div'>
                  <PhoneIcon />
                </div>
                <div className='info-text'>
                  Phone Number
                </div>
              </div>
              <div className='part-right'>
                {contact.phones?.length > 0 && <div className='part-right-info'>
                  {contact.phones && contact.phones.map((phone) => {
                    return (
                      <div className='phone-div' key={JSON.stringify(contact.phones) + phone}>
                        {phone}
                      </div>
                    )
                  })}
                </div>}
                <div className='add-info' onClick={() => { modalService.open(<AddInfoModal type='phone-number' contact={contact} phoneNumbers={contact.phones}/>) }}>
                  Add phone number +
                </div>
              </div>
            </div>
            <div className='info-div'>
              <div className='part-left'>
                <div className='icon-div'>
                  <LetterIcon />
                </div>
                <div className='info-text'>
                  Email
                </div>
              </div>
              <div className='part-right'>
                {contact.emails?.length > 0 && <div className='part-right-info'>
                  {contact.emails && contact.emails.map((email) => {
                    return (
                      <div className='email-div' key={JSON.stringify(contact.emails) + email}>
                        {email}
                      </div>
                    )
                  })}
                </div>
                }
                <div className='add-info' onClick={() => { modalService.open(<AddInfoModal type='email' contact={contact} emails={contact.emails}/>) }}>
                  Add email address +
                </div>
              </div>
            </div>
            <div className='info-div'>
              <div className='part-left'>
                <div className='icon-div'>
                  <WebsiteIcon />
                </div>
                <div className='info-text'>
                  Website
                </div>
              </div>
              <div className='part-right'>
                <div className='part-right-info'>
                  {contact.website ? <a href={contact.website} target="_blank" rel="noreferrer">{contact.website}</a> : '-'}
                </div>
              </div>
            </div>
            <div className='info-div'>
              <div className='part-left'>
                <div className='icon-div'>
                  <AddressIcon />
                </div>
                <div className='info-text'>
                  Address
                </div>
              </div>
              <div className='part-right'>
                {contact.addresses?.length > 0 && <div className='part-right-info'>
                  {contact.addresses && contact.addresses.map((address) => {
                    return (
                      <div className='address-div' key={JSON.stringify(contact.addreses) + address}>
                        {address}
                      </div>
                    )
                  })}
                </div>
                }
                <div className='add-info' onClick={() => { modalService.open(<AddInfoModal type='address' contact={contact} emails={contact.addresses}/>) }}>
                  Add an address +
                </div>
              </div>
            </div>
            <div className='info-div'>
              <div className='part-left'>
                <div className='icon-div'>
                  <NotesIcon />
                </div>
                <div className='info-text'>
                  Notes
                </div>
              </div>
              <div className='part-right'>
                <div className='part-right-info'>
                  {contact.notes || '-'}
                </div>
              </div>
            </div>
            <div className='labels-div'>
              <div className='part-top'>
                <div className='icon-div'>
                  <LabelsIcon />
                </div>
                <div className='labels-text'>
                  Labels
                </div>
              </div>
              <div className='part-bottom'>
                {contact.contactlabels?.map((label, index) => <div key={index} className='contact-label'>
                  <div className='label-badge'>
                    {label.name}
                  </div>
                </div>)
                }
                <div className='label-badge add' onClick={openAddLabelToContactModal}>
                  +
                </div>
              </div>
            </div>
          </div>
          <div className='contact-profile-buttons'>
            <div className='delete-contact-button' onClick={() => deleteContact(contact)}>
              <div className='delete-icon'>
                <DeleteIcon />
              </div>
              <div className='delete-text'>
                Delete Contact
              </div>
            </div>
            {/* <div className='export-contact-button'>
              <div className='export-icon'>
                <ExportIcon />
              </div>
              <div className='export-text'>
                Export Contact
              </div>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactProfile
